class HotelPartners extends HTMLElement {
  constructor() {
    super();
    this.loadMoreButton = this.querySelector(".hotel-partners__load-more");

    if (!this.loadMoreButton) return;

    this.items = this.querySelectorAll(".hotel-partners__item");
    this.loadMoreButton.addEventListener("click", () => {
      this.loadMoreButton.classList.add("hidden");
      this.items.forEach((item) =>
        item.classList.remove("hotel-partners__item--hidden-on-mobile"),
      );
    });
  }
}

if (!customElements.get("section-hotel-partners")) {
  customElements.define("section-hotel-partners", HotelPartners);
}
